export const UPDATE_AVAILABLE_NOTIFICATION_ID = "watchtower-app-update";

export const UPDATE_AVAILABLE_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export const UPDATE_AVAILABLE_NOTIFICATION_TITLE = "Update Available";

export const UPDATE_AVAILABLE_NOTIFICATION_MESSAGE =
    "A new version is available. Please refresh the page at your earliest convenience.";
